module.exports = __webpack_public_path__ + "img/new_profile_icon.ee8b259.png";